import { t } from "i18next";
import DBButton from "../../component/global/DBButton";
import DBModal from "../../component/global/DBModal";

const HELP_SECTIONS = [
    "overview",
    "profiles",
    "suppression",
    "workflow",
    "notes",
];

export default function SettingsHelpModal({ show, onHide }) {
    return (
        <DBModal
            permanent
            show={show}
            minWidth={640}
            onHide={onHide}
            className="survey-settings-help-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                closeLabel={t("survey.settings.help.close")}
                title={t("survey.settings.help.title")}
            />
            <DBModal.Content>
                <div className="survey-settings-help">
                    {HELP_SECTIONS.map((section) => (
                        <section key={section}>
                            <h5>{t(`survey.settings.help.${section}.title`)}</h5>
                            <p>{t(`survey.settings.help.${section}.body`)}</p>
                        </section>
                    ))}
                </div>
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("survey.settings.help.close")}
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
